export default {
  GET_TASKS_REQUEST: 'GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS: 'GET_TASKS_SUCCESS',
  GET_TASKS_FAIL: 'GET_TASKS_FAIL',

  GET_TASKS_HISTORY_REQUEST: 'GET_TASKS_HISTORY_REQUEST',
  GET_TASKS_HISTORY_SUCCESS: 'GET_TASKS_HISTORY_SUCCESS',
  GET_TASKS_HISTORY_FAIL: 'GET_TASKS_HISTORY_FAIL',

  GET_TASKS_VERIFIED_REQUEST: 'GET_TASKS_VERIFIED_REQUEST',
  GET_TASKS_VERIFIED_SUCCESS: 'GET_TASKS_VERIFIED_SUCCESS',
  GET_TASKS_VERIFIED_FAIL: 'GET_TASKS_VERIFIED_FAIL',

  UPDATE_TASK_REQUEST: 'UPDATE_TASK_REQUEST',
  UPDATE_TASK_SUCCESS: 'UPDATE_TASK_SUCCESS',
  UPDATE_TASK_FAIL: 'UPDATE_TASK_FAIL',

  ACCEPT_TASK_REQUEST: 'ACCEPT_TASK_REQUEST',
  ACCEPT_TASK_SUCCESS: 'ACCEPT_TASK_SUCCESS',
  ACCEPT_TASK_FAIL: 'ACCEPT_TASK_FAIL',

  GET_TASK_IMAGE_REQUEST: 'GET_TASK_IMAGE_REQUEST',
  GET_TASK_IMAGE_SUCCESS: 'GET_TASK_IMAGE_SUCCESS',
  GET_TASK_IMAGE_FAIL: 'GET_TASK_IMAGE_FAIL',
  CLEAR_TASK_IMAGES: 'CLEAR_TASK_IMAGES',

  GET_COUNT_TASK_REQUEST: 'GET_COUNT_TASK_REQUEST',
  GET_COUNT_TASK_SUCCESS: 'GET_COUNT_TASK_SUCCESS',
  GET_COUNT_TASK_FAIL: 'GET_COUNT_TASK_FAIL',

  VERIFY_TASKS_REQUEST: 'VERIFY_TASKS_REQUEST',
  VERIFY_TASKS_SUCCESS: 'VERIFY_TASKS_SUCCESS',
  VERIFY_TASKS_FAIL: 'VERIFY_TASKS_FAIL',

  SYNCHRONIZE_TASKS_REQUEST: 'SYNCHRONIZE_TASKS_REQUEST',
  SYNCHRONIZE_TASKS_SUCCESS: 'SYNCHRONIZE_TASKS_SUCCESS',
  SYNCHRONIZE_TASKS_FAIL: 'SYNCHRONIZE_TASKS_FAIL',
  
  SKIP_TASK_REQUEST: 'SKIP_TASK_REQUEST',
  SKIP_TASK_SUCCESS: 'SKIP_TASK_SUCCESS',
  SKIP_TASK_FAIL: 'SKIP_TASK_FAIL',

  VERIFY_TASK_REQUEST: 'VERIFY_TASK_REQUEST',
  VERIFY_TASK_SUCCESS: 'VERIFY_TASK_SUCCESS',
  VERIFY_TASK_FAIL: 'VERIFY_TASK_FAIL',

  AFFIRM_TASK_REQUEST: 'AFFIRM_TASK_REQUEST',
  AFFIRM_TASK_SUCCESS: 'AFFIRM_TASK_SUCCESS',
  AFFIRM_TASK_FAIL: 'AFFIRM_TASK_FAIL',

  CHANGE_COUNT_TASK: 'CHANGE_COUNT_TASK',
}